export enum TipoRelacionamentoEnum {

  Contador,
  Outro,
  ResponsavelTecnico,
  Socio
}
